import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GroupSettingsHeaderProps } from '@modules/digital-signage/model/group-settings.model.ts';
import { isRealDeviceGroup } from '@modules/digital-signage/utils/digital-signage.utils.ts';

const GroupSettingsHeader: React.FC<GroupSettingsHeaderProps> = ({
  group,
  deviceName
}) => {
  const { t } = useTranslation();

  const title = isRealDeviceGroup(group)
    ? group?.name
    : (deviceName ?? t('digital_signage_add_device_group_title'));
  const devicesCount = group?.devicesCount ?? group?.devices?.length ?? 0;

  return (
    <div className="flex flex-col gap-1">
      <Typography
        variant="subtitle1"
        className="text-(--dark-1)! max-lg-xl:text-[18px]!"
      >
        {title}
      </Typography>

      <Typography variant="caption" className="text-(--dark-1)!">
        {t('column_label_devices')}: {devicesCount}
      </Typography>
    </div>
  );
};

export default GroupSettingsHeader;
